//React components 
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
//Components 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ErrorAlert from '../Alerts/ErrorAlert';
import { Container } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import Modal from 'react-bootstrap/Modal'

import refund from '../img/icons/refund.png'
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';

//PDF
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
//Utils
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
//IMG
import defaultImage from "../../assets/img/default.png";
import './DetailPreOrder/ModalDetailPreOrder.css';


const ModalDetailPreOrder = ({ orderData }) => {
    const [show, setShow] = useState(false);
    //Total taxes 
    const [totalTaxes, setTotalTaxes] = useState([
        { total_base: 0, tax: "0%", total_tax: 0 },
        { total_base: 0, tax: "7%", total_tax: 0 },
        { total_base: 0, tax: "10%", total_tax: 0 },
        { total_base: 0, tax: "15%", total_tax: 0 }])
    const [branchOfficeData, setBranchofficeData] = useState({
        "ruc": "", "dv": "", "name": "", "ruc_type": "", "direction": "", "dgi_name": "",
    });

    //We charge the items of the order 
    const orderItems = () => {
        let items = orderData.groups.map((product) => (
            <React.Fragment key={product._id}>
                {product.type == "separator" ? <>
                    <div className="sp-dpo-sep">
                        <span className="sp-dpo-sep__label"><i className="uil uil-arrow-from-top"></i> {product.name}</span>
                    </div>
                </> : <>
                    <div className="sp-dpo-item">
                        <img className="sp-dpo-item__thumb" loading="lazy" src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" alt={product.name} />
                        <div className="sp-dpo-item__body">
                            <div className="sp-dpo-item__top">
                                <span className="sp-dpo-item__name">{product.name}</span>
                                <div className="sp-dpo-item__right">
                                    <span className="sp-dpo-item__qty" translate="no">x {product.amount}</span>
                                    <span className="sp-dpo-item__price" translate="no">$ {product.price.toFixed(2)}</span>
                                </div>
                            </div>
                            {product.segments.map((segments) => (
                                <div className="sp-dpo-item__seg" key={segments._id}>
                                    <span>{segments.item.name}</span>
                                </div>
                            ))}
                            <div className="sp-dpo-item__extra">
                                <small className="sp-dpo-item__delivery">Entrega: {product.delivery_type}</small>
                                <RenderIf isTrue={product.note != ""}>
                                    <small className="sp-dpo-item__note">Nota: {product.note}</small>
                                </RenderIf>
                            </div>
                        </div>
                    </div>
                </>}
            </React.Fragment>
        ));
        return <>{items}</>
    }

    //Template card Group of setGroup
    const cardGroup = (product) => {
        return (
            <>
                {product.type == "separator" ? <>
                    <div className="sp-dpo-sub sp-dpo-sub--sep">
                        <h5 className="sp-dpo-sub__title"><i className="uil uil-arrow-from-top"></i> {product.name}</h5>
                    </div>
                </> : <>
                    <div className="sp-dpo-sub">
                        <img loading="lazy" src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} className="sp-dpo-sub__thumb" alt="..." width="40" height="40" />
                        <div className="sp-dpo-sub__body">
                            <h5 className="sp-dpo-sub__title">{product.name}</h5>
                            <details className="sp-dpo-details">
                                <summary className="sp-dpo-details__sum"><i className="uil uil-info-circle"></i> Detalles</summary>
                                <div className="sp-dpo-details__list">
                                    {product.segments.map((item, idx) => (
                                        <div className="sp-dpo-details__seg" key={idx}>
                                            <span className="sp-dpo-details__segname">{item.name}:</span>
                                            <strong><span className="sp-dpo-details__itemname">{item.item.name}</span> {parseFloat(item.item.price).toFixed(2)}</strong>
                                        </div>
                                    ))}
                                </div>
                            </details>
                        </div>
                    </div>
                </>}
            </>
        )
    }

    const orderCombos = () => {
        let items = orderData.combos.map((product) => (
            <div className="sp-dpo-item" key={product.combo_id}>
                <img className="sp-dpo-item__thumb" loading="lazy" src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" alt={product.name} />
                <div className="sp-dpo-item__body">
                    <div className="sp-dpo-item__top">
                        <span className="sp-dpo-item__name">{product.name}</span>
                        <div className="sp-dpo-item__right">
                            <span className="sp-dpo-item__qty" translate="no">x {product.amount}</span>
                            <span className="sp-dpo-item__price" translate="no">$ {product.price.toFixed(2)}</span>
                        </div>
                    </div>

                    {product.setGroups.map((setGroup) => (
                        <div className="sp-dpo-item__setgroup" key={setGroup.set_id}>
                            <details className="sp-dpo-details">
                                <summary className="sp-dpo-details__sum"><i className="uil uil-info-circle"></i> {setGroup.name}</summary>
                                <div className="sp-dpo-details__subs">
                                    {setGroup.groups.map((group, idx) => (
                                        <React.Fragment key={idx}>{cardGroup(group)}</React.Fragment>
                                    ))}
                                </div>
                            </details>
                        </div>
                    ))}

                    <div className="sp-dpo-item__extra">
                        <small className="sp-dpo-item__delivery">Entrega: {product.delivery_type}</small>
                        <RenderIf isTrue={product.note != ""}>
                            <small className="sp-dpo-item__note">Nota: {product.note}</small>
                        </RenderIf>
                    </div>
                </div>
            </div>
        ));
        return <>{items}</>
    }

    useEffect(() => {
        (async () => {
            try {
                const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(orderData.business.code, orderData.branchoffice.code);
                setBranchofficeData(response_branch.data.branchoffice);
            } catch (err) {
                setBranchofficeData({ "ruc": "", "dv": "", "name": "", "ruc_type": "", "direction": "", "dgi_name": "" })
            }
        })();
    }, []);

    return (<>

        {/* ── Tarjeta resumen (abre el modal) ── */}
        <div className="sp-dpo-card" onClick={() => setShow(true)}>
            <div className="sp-dpo-card__icon">
                <img loading="lazy" src={refund} alt="En progreso" width="40" height="40" />
            </div>
            <div className="sp-dpo-card__body">
                <div className="sp-dpo-card__top">
                    <h5 className="sp-dpo-card__order">Orden #{orderData.transaction_code}</h5>
                    <h5 className="sp-dpo-card__total">Total: <strong translate="no">${orderData.total.toFixed(2)}</strong></h5>
                </div>
                <span className="sp-dpo-card__row"><i className="uil uil-user-circle"></i> Cliente: {orderData.client_name}</span>
                <span className="sp-dpo-card__row"><i className="fa-solid fa-cash-register"></i> {!orderData.machine_name ? 'No es caja' : orderData.machine_name} / {!orderData.user ? 'No es cajera' : orderData.user.name}</span>
                <span className="sp-dpo-card__row is-muted"><i className="fa-solid fa-mobile-screen"></i> Máquina: {orderData.machine_code}</span>
                <div className="sp-dpo-card__foot">
                    <span className="sp-dpo-card__row is-muted"><i className="fa-solid fa-store"></i> Sucursal: {orderData.branchoffice.name}</span>
                    <span className="sp-dpo-card__row is-muted"><i className="uil uil-list-ol"></i> Productos: {(orderData.groups.length + orderData.combos.length)}</span>
                    <span className="sp-dpo-card__see"><i className="uil uil-eye"></i> Ver detalle</span>
                </div>
            </div>
        </div>

        {/* ── Modal de detalle ── */}
        <Modal show={show} size="xl" onHide={() => setShow(false)} centered dialogClassName="sp-dpo-dialog" contentClassName="sp-dpo-content">
            <Modal.Body className="sp-dpo">

                {/* Header */}
                <div className="sp-dpo__head">
                    <div className="sp-dpo__badge"><i className="uil uil-receipt"></i></div>
                    <h3 className="sp-dpo__title">Detalles</h3>
                    <button className="sp-dpo__x" type="button" aria-label="Cerrar" onClick={() => setShow(false)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                    </button>
                </div>

                {/* Cuerpo scrollable */}
                <div className="sp-dpo__body">
                    {/* Cabecera de la cotización */}
                    <div className="sp-dpo__invoice-head">
                        <div className="sp-dpo__type"><span>{orderData.order_type}</span></div>
                        <div className="sp-dpo__code">Cotizacion: <span># {orderData.transaction_code ? orderData.transaction_code : 0}</span></div>
                    </div>

                    <div className="sp-dpo__meta">
                        <span><i className="uil uil-user-circle"></i> Cliente: {orderData.client_name}</span>
                        <span><i className="fa-solid fa-store"></i> Sucursal: {orderData.branchoffice.name}</span>
                        <span><i className="uil uil-list-ol"></i> Cantidad de productos: {(orderData.groups.length + orderData.combos.length)}</span>
                        <span><i className="fa-solid fa-cash-register"></i> {orderData.machine_name} / {!orderData.user ? 'No es cajera' : orderData.user.name}</span>
                    </div>

                    {/* Encabezado lista */}
                    <div className="sp-dpo__listhead">
                        <span>Productos</span>
                        <span>Precio</span>
                    </div>

                    {/* Items */}
                    <div className="sp-dpo__items">
                        {orderItems()}
                        {orderCombos()}
                    </div>

                    {/* Totales */}
                    <div className="sp-dpo__totals">
                        <div className="sp-dpo__trow">
                            <span>Descuento</span>
                            <span className="is-danger" translate="no">- $ {orderData.discount.toFixed(2)}</span>
                        </div>
                        <div className="sp-dpo__trow">
                            <span>Subtotal</span>
                            <span translate="no">$ {orderData.subtotal.toFixed(2)}</span>
                        </div>
                        {orderData.taxes.map((tax, idx) => (
                            <React.Fragment key={idx}>
                                {tax.total.toFixed(3) > 0 ?
                                    <div className="sp-dpo__trow">
                                        <span>Impuesto {tax.tax}</span>
                                        <span translate="no">$ {tax.total.toFixed(3)}</span>
                                    </div> : <></>}
                            </React.Fragment>
                        ))}
                        <div className="sp-dpo__trow sp-dpo__trow--total">
                            <span>Total</span>
                            <span translate="no">$ {orderData.total.toFixed(2)}</span>
                        </div>
                    </div>

                    {/* PDF */}
                    <div className="sp-dpo__pdf">
                        <PDFDownloadLink className="sp-dpo__pdflink" document={<DocPdf
                            doc_type={"price"} invoiceQR={"0"} invoiceDate={orderData.createdAt} cufe={"0"} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                            receptor={{ name: orderData.client_name, ruc: orderData.client_ruc, direction: "Panama", dv: orderData.client_dv }}
                            emitter={branchOfficeData}
                            products={orderData.groups} invoiceSubtotal={orderData.subtotal} totalTaxes={totalTaxes}
                            totalCashReceived={orderData.total} invoiceTotal={orderData.total} invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}
                        />}>
                            <button className="sp-dpo__btn sp-dpo__btn--pdf"><i className="uil uil-file-download-alt"></i> {orderData.invoice_type === "devolution" ? "Descargar nota de credito" : "Descargar factura electronica"}</button>
                        </PDFDownloadLink>
                    </div>
                </div>

                {/* Footer */}
                <div className="sp-dpo__foot">
                    <button className="sp-dpo__btn sp-dpo__btn--cancel" onClick={() => setShow(false)}>Cerrar</button>
                </div>

            </Modal.Body>
        </Modal>
    </>);
}

export default ModalDetailPreOrder;